/**
 * cm-menu.js: the header mega menu, in mymobilitycenter.com's format (2026-10-12).
 *
 * Desktop (1240px and up): a top-level item opens its panel on hover (mouse only),
 * focus or click. A panel stays open until another opens, a click lands outside,
 * focus leaves the menu, or Escape is pressed. Clicking an open item follows its link.
 * Inside a panel, hovering or focusing a group shows its photo card.
 *
 * Below 1240px: the Menu button opens a drawer under the header. Top-level items
 * open as an accordion; each panel's groups start closed and open on tap, with the
 * group's card moved directly under it, and the "See ..." button moved under the groups.
 *
 * Without JavaScript every link still goes to its page.
 */
(function () {
  'use strict';

  var WIDE = window.matchMedia('(min-width: 1240px)');
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init() {
    var nav = document.getElementById('cm-primary-nav');
    var toggle = document.querySelector('.cm-nav-toggle');
    if (!nav) return;
    var items = Array.prototype.slice.call(nav.querySelectorAll('.cm-has-panel'));
    var header = document.querySelector('[data-header]');

    function linkOf(item) { return item.querySelector('.cm-menu-link'); }

    function setOpen(item, on) {
      item.classList.toggle('is-open', on);
      var a = linkOf(item);
      if (a) a.setAttribute('aria-expanded', on ? 'true' : 'false');
    }

    function openOnly(item) { items.forEach(function (o) { setOpen(o, o === item); }); }
    function closeAll() { items.forEach(function (o) { setOpen(o, false); }); }

    /* ---- Drawer ---- */

    function drawerOpen() { return nav.classList.contains('is-open'); }

    function sizeDrawer() {
      if (!header) return;
      var bottom = header.getBoundingClientRect().bottom;
      nav.style.maxHeight = Math.max(200, window.innerHeight - bottom) + 'px';
    }

    function setDrawer(on) {
      nav.classList.toggle('is-open', on);
      document.body.classList.toggle('cm-nav-open', on);
      if (toggle) toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) { sizeDrawer(); } else { nav.style.maxHeight = ''; closeAll(); }
    }

    if (toggle) {
      toggle.addEventListener('click', function () { setDrawer(!drawerOpen()); });
    }

    window.addEventListener('resize', function () { if (drawerOpen()) sizeDrawer(); });

    /* ---- Top level ---- */

    var quietFocus = false; // set while Escape hands focus back, so the focus does not reopen the panel

    items.forEach(function (item) {
      var a = linkOf(item);
      if (!a) return;

      // Mouse only: a touch tap fires a simulated hover that would open the
      // panel just before the click, which would then follow the link.
      item.addEventListener('pointerenter', function (e) {
        if (WIDE.matches && e.pointerType === 'mouse') openOnly(item);
      });

      a.addEventListener('focus', function () { if (WIDE.matches && !quietFocus) openOnly(item); });

      a.addEventListener('click', function (e) {
        if (!WIDE.matches) {
          e.preventDefault();
          setOpen(item, !item.classList.contains('is-open'));
          return;
        }
        if (!item.classList.contains('is-open')) {
          e.preventDefault();
          openOnly(item);
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (WIDE.matches && !e.target.closest('.cm-has-panel')) closeAll();
    });

    nav.addEventListener('focusout', function (e) {
      if (WIDE.matches && e.relatedTarget && !nav.contains(e.relatedTarget)) closeAll();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openItem = items.filter(function (i) { return i.classList.contains('is-open'); })[0];
      if (WIDE.matches) {
        if (openItem) { closeAll(); var l = linkOf(openItem); if (l) { quietFocus = true; l.focus({ preventScroll: true }); quietFocus = false; } }
        return;
      }
      if (drawerOpen()) {
        setDrawer(false);
        if (toggle) toggle.focus();
      }
    });

    /* ---- Second level: groups ---- */

    var megas = Array.prototype.slice.call(nav.querySelectorAll('.cm-mega'));

    function groupsOf(mega) { return Array.prototype.slice.call(mega.querySelectorAll('.cm-mega-group')); }
    function subsOf(mega) { return Array.prototype.slice.call(mega.querySelectorAll('.cm-mega-sub')); }

    function show(mega, group) {
      var key = group ? group.getAttribute('data-group') : null;
      groupsOf(mega).forEach(function (g) {
        var on = g === group;
        g.classList.toggle('is-active', on);
        var a = g.querySelector('a');
        if (a) a.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      subsOf(mega).forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-sub') === key); });
    }

    // Desktop: each card sits in the right-hand column and the first group shows.
    // Drawer: each card sits inside its group, every group starts closed, and the
    // "See ..." button sits under the groups (MMC owner rule, 2026-10-09).
    function reflow() {
      megas.forEach(function (mega) {
        var subsBox = mega.querySelector('.cm-mega-subs');
        subsOf(mega).forEach(function (sub) {
          var g = mega.querySelector('.cm-mega-group[data-group="' + sub.getAttribute('data-sub') + '"]');
          if (!g || !subsBox) return;
          if (!WIDE.matches) { if (sub.parentNode !== g) g.appendChild(sub); }
          else if (sub.parentNode !== subsBox) subsBox.appendChild(sub);
        });
        show(mega, WIDE.matches ? groupsOf(mega)[0] : null);

        var lede = mega.querySelector('.cm-mega-lede');
        var list = mega.querySelector('.cm-mega-groups');
        var cta = mega.querySelector('.cm-mega-cta[data-lede-cta]');
        if (cta && lede && list) {
          if (!WIDE.matches) { if (cta.previousElementSibling !== list) list.parentNode.insertBefore(cta, list.nextSibling); }
          else if (cta.parentNode !== lede) lede.appendChild(cta);
        }
      });
    }

    reflow();
    var onChange = function () { if (WIDE.matches && drawerOpen()) setDrawer(false); closeAll(); reflow(); };
    if (WIDE.addEventListener) WIDE.addEventListener('change', onChange); else if (WIDE.addListener) WIDE.addListener(onChange);

    megas.forEach(function (mega) {
      groupsOf(mega).forEach(function (group) {
        var a = group.querySelector('a');
        if (!a) return;
        group.addEventListener('pointerenter', function (e) { if (WIDE.matches && e.pointerType === 'mouse') show(mega, group); });
        a.addEventListener('focus', function () { if (WIDE.matches) show(mega, group); });
        a.addEventListener('click', function (e) {
          if (!WIDE.matches) {
            e.preventDefault();
            var wasOpen = group.classList.contains('is-active');
            show(mega, wasOpen ? null : group);
            if (!wasOpen && !REDUCE.matches && group.scrollIntoView) {
              var r = group.getBoundingClientRect(), n = nav.getBoundingClientRect();
              if (r.top < n.top || r.top > n.bottom - 80) group.scrollIntoView({ block: 'nearest' });
            }
            return;
          }
          if (group.classList.contains('is-active')) return;
          e.preventDefault();
          show(mega, group);
        });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
